import type { QTableColumn } from 'quasar';
import { formatDate } from 'src/utils/formatDate';
export interface GroupTypeModelInput {
  id: string;
  name: string;
  description: string;
  created_at: string;
  updated_at: string;
}
export interface GroupTypeModelCreateAttributes {
  name: string;
  description: string;
}
export interface GroupTypeModelUpdateAttributes {
  name: string;
  description: string;
}
export interface GroupTypeModelAttributes {
  id: string;
  name: string;
  description: string;
  created_at: string;
  updated_at: string;
}
export class GroupTypeModel {
  id: string;
  name: string;
  description: string;
  created_at: string;
  updated_at: string;

  constructor(input?: GroupTypeModelInput) {
    this.id = input ? input.id : '';
    this.name = input ? input.name : '';
    this.description = input ? input.description : '';
    this.created_at = input ? formatDate(input.created_at) : '';
    this.updated_at = input ? formatDate(input.updated_at) : '';
  }

  getId(): string {
    return this.id;
  }
  getAttributes(): GroupTypeModelAttributes {
    return {
      id: this.id,
      name: this.name,
      description: this.description,
      created_at: this.created_at,
      updated_at: this.updated_at,
    };
  }
  getCreateAttributes(): GroupTypeModelCreateAttributes {
    return {
      name: this.name,
      description: this.description,
    };
  }
  getUpdateAttributes(): GroupTypeModelUpdateAttributes {
    return {
      name: this.name,
      description: this.description,
    };
  }
}
export type GroupTypeCollection = GroupTypeModel[];
export const GroupTypeTableColumns: QTableColumn[] = [
  {
    name: 'id',
    label: 'ID',
    align: 'left',
    field: 'id',
    sortable: true,
  },
  {
    name: 'name',
    label: 'グループタイプ名',
    align: 'left',
    field: 'name',
    sortable: true,
  },
  {
    name: 'description',
    label: '説明',
    align: 'left',
    field: 'description',
    sortable: false,
  },
  {
    name: 'created_at',
    label: '作成日',
    align: 'left',
    field: 'created_at',
    sortable: true,
  },
];
